export var EntityTypeEnum;
(function (EntityTypeEnum) {
    EntityTypeEnum["ORGANIZATION"] = "Organization";
    EntityTypeEnum["ORGANIZATION_ADMIN"] = "Organization Admin";
    EntityTypeEnum["PROVIDER"] = "Provider";
    EntityTypeEnum["PRIORITY_ENTRY"] = "Priority Search Result";
    EntityTypeEnum["PRIORITY_NOTE"] = "Priority Note";
    EntityTypeEnum["PROVIDER_SEARCH"] = "Provider Search";
    EntityTypeEnum["CAREGIVER"] = "Caregiver";
    EntityTypeEnum["CASE_MANAGER"] = "Case Manager";
    EntityTypeEnum["PATIENT"] = "Patient";
    EntityTypeEnum["LOCATION"] = "Location";
    EntityTypeEnum["INSURANCE"] = "Insurance";
    EntityTypeEnum["CONDITION"] = "Condition";
    EntityTypeEnum["THERAPY_CATEGORY"] = "Therapy Category";
    EntityTypeEnum["THERAPY_SUB_CATEGORY"] = "Therapy Sub Category";
    EntityTypeEnum["POSTAL_CODE"] = "Zip Code";
})(EntityTypeEnum || (EntityTypeEnum = {}));
